/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

/**
 * React component wrapper around datatables.net
 * https://datatables.net
 * https://www.npmjs.com/package/datatables.net
 *
 * based on:
 * https://www.npmjs.com/package/react-datatables
 * https://github.com/luqin/react-DataTables
 */

import React from 'react';
import ReactDOM from 'react-dom';

import $ from 'jquery'; // eslint-disable-line

import 'datatables.net';
import {WrcDataTable} from "./WrcDataTables.js";
import PropTypes from "prop-types";

import './WrcSchedulingInputCP.css';
import {NonIdealState} from "@blueprintjs/core";
import {Button, Checkbox, Classes, Dialog, HTMLSelect, TextArea, Position} from "@blueprintjs/core";
import {DateInput} from "@blueprintjs/datetime";
import {WrcServer} from "./WrcServer.js";
import {WrcGlobal} from "./WrcGlobal.js";


export class WrcSchedulingInputCP extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loaded: false,
            importTable: undefined,
            readyImport: false,
            data: {},
            medical_providers: {},
            importSelector: []
        };
    }

    componentDidMount() {
        let payload = {
            table_schema: 'app',
            table_name: 'kap_medical_provider',
            study: this.props.registry,
        };
        WrcServer.post('get-kap-medical-providers',
            payload,
            (content) => this.getProviders(content)
        );
    }

    getProviders(content) {
        this.setState({
            medical_providers: content,
            is_loaded: true
        });
    }

    render() {
        if (!this.state.is_loaded) {
            return (<div>Retrieving medical provider list...</div>);
        }

        let renderedSchedule = '';

        if (this.state.importTable === undefined) {
            renderedSchedule = (
                <NonIdealState className='non-ideal-state' icon='calendar' title='No Scheduling Information' description='Paste scheduling info above.'/>
            );
        }
        else {
            let rows = this.state.importTable['rows'].map((row, index) => {
                let tag = (
                    <tr>
                        <td>
                            <Checkbox
                                    inline={true}
                                    label={""}
                                    style={{textAlign: 'center'}}
                                    checked={this.state.importSelector[index] === 't'}
                                    onChange={this.handleCheckbox(index)} />
                        </td>
                        {row}
                    </tr>
                );
                return tag;
            });
            renderedSchedule = (
                <WrcDataTable
                        index={this.props.component_index}
                        entity="schedule"
                        hidden_columns={this.state.importTable['hidden_columns']}
                        page_length={this.props.page_length}
                        noWrapHeader={false}
                        show_search={false}>
                    <thead>
                        {this.state.importTable['header']}
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </WrcDataTable>
            );
        }

        let selectOptionList = this.state.medical_providers.map(function(provider) {
            if (provider.status == 'Former') return;
            let label = provider.first_name + ' ' + provider.last_name;
            return (
                <option value={provider.id}>{label}</option>
            );
        });
        // Allow date control to range from 1900 to the end of the year 20 years in the future
        let minDate = new Date(1900, 0, 1);
        let maxDate = new Date(new Date().getFullYear() + 20, 11, 31);
        return (
            <Dialog
                    isOpen={true}
                    onClose={this.closeSchedule}
                    canOutsideClickClose={false}
                    title="Schedule"
                    id="schedule_input"
                    style={{minWidth: 1100, minHeight: 600, maxWidth: 1400, maxHeight: 800, overflow: 'scroll'}} >
                <div className={Classes.DIALOG_BODY}>
                    <div class="wd-form-label">Medical Provider</div>
                    <div className={'wd-form-inputgroup-vertical-layout wd-form-select'}>
                        <HTMLSelect
                                name={'provider'}
                                onChange={this.handleInputChange}>
                            <option value="">Select...</option>
                            {selectOptionList}
                        </HTMLSelect>
                    </div>
                    <div class="wd-form-label" style={{clear: 'both', paddingTop: '1em'}}>Start date</div>
                    <div class="wd-form-inputgroup-vertical-layout">
                        <div class="bp3-control-group bp3-vertical">
                            <DateInput
                                minDate={minDate}
                                maxDate={maxDate}
                                formatDate= {date => this.formatDate(date)}
                                parseDate= {str => this.parseDate(str)}
                                onChange={(selectedDate, isUserChange) => this.handleDateChange({newDate: selectedDate, field_name: 'start_date'})}
                                placeholder={"YYYY-MM-DD"}
                                value={this.state.data['start_date'] ? this.stringToDate(this.state.data['start_date']) : null}
                                popoverProps={{ position: Position.BOTTOM }}
                            />
                        </div>
                    </div>
                    <div class="wd-form-label" style={{clear: 'both', paddingTop: '1em'}}>End date</div>
                    <div class="wd-form-inputgroup-vertical-layout">
                        <div class="bp3-control-group bp3-vertical">
                            <DateInput
                                minDate={minDate}
                                maxDate={maxDate}
                                formatDate= {date => this.formatDate(date)}
                                parseDate= {str => this.parseDate(str)}
                                onChange={(selectedDate, isUserChange) => this.handleDateChange({newDate: selectedDate, field_name: 'end_date'})}
                                placeholder={"YYYY-MM-DD"}
                                value={this.state.data['end_date'] ? this.stringToDate(this.state.data['end_date']) : null}
                                popoverProps={{ position: Position.BOTTOM }}
                            />
                        </div>
                    </div>
                    <div id='textarea-container' style={{clear: 'both', paddingTop: '1em'}}>
                        <TextArea
                                growVertically={true}
                                fill={true}
                                large={true}
                                intent="primary"
                                placeholder="Paste scheduling information here..."
                                onPaste={this.handlePaste}>
                        </TextArea>
                    </div>
                    <div id='schedule-container'>
                        {renderedSchedule}
                    </div>
                    <Button onClick={this.clickImport} text="Import" type={'button'} style={{margin:10}} disabled={!this.state.readyImport}/>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={'bp3-dialog-footer-actions'} style={{float: 'right', padding: 10}}>
                        <Button onClick={this.closeSchedule} text="Close" type={'button'}/>
                    </div>
                </div>
            </Dialog>
        );
    }

    handleInputChange = (e) => {
        e.persist();
        var data = Object.assign({}, this.state.data);
        data[e.target.name] = e.target.value;
        this.setState({data: data});
    }

    stringToDate = (dateString) => {
        // from: https://stackoverflow.com/questions/5619202/converting-a-string-to-a-date-in-javascript
        let parts =dateString.split('-');
        // Please pay attention to the month (parts[1]); JavaScript counts months from 0:
        // January - 0, February - 1, etc.
        let mydate = new Date(parts[0], parts[1] - 1, parts[2]);
        return mydate;
    }

    dateToString = (stringDate) => {
        let year= stringDate.getFullYear().toString();
        let month= (stringDate.getMonth() + 1).toString().length == 1 ?
            '0'+ (stringDate.getMonth() + 1).toString() :
            (stringDate.getMonth() + 1).toString();
        let day= (stringDate.getDate()).toString().length == 1 ?
            '0'+ (stringDate.getDate()).toString() :
            (stringDate.getDate()).toString();
        let newDateString = year + '-' + month + '-' + day;
        return newDateString;
    }

    formatDate = (inDate) => {
        let outDate= (inDate == null ? "" : this.dateToString(inDate));
        return outDate;
    }

    parseDate = (inStr) => {
        let outStr= this.stringToDate(inStr);
        return outStr;
    }

    handleDateChange = (newDateObj) =>{
        let newDateString = this.dateToString(newDateObj.newDate);
        var latest = Object.assign({}, this.state.data);
        latest[newDateObj.field_name] = newDateString;
        this.setState({data: latest, has_changed: true});
    }

    handlePaste = (e) => {
        e.persist();

        let importTable = {};
        let pastedData = e.clipboardData.getData('text/plain').trim();
        let rows = pastedData.split("\n");

        let hidden_columns = [];
        let cols = rows[0].split("\t").map(function(col, index) {
            if (col === 'Duration' || col === 'Location') {
                hidden_columns.push(index + 1); // Add 1 because we are adding import column at beginning.
            }
            return (<th>{col}</th>);
        });
        cols.unshift((<th>{'Import'}</th>));
        cols.push((<th>{'Age'}</th>));
        importTable['header'] = (<tr>{cols}</tr>);
        importTable['rows'] = [];
        importTable['scheduled_visit_list'] = [];
        importTable['hidden_columns'] = hidden_columns;

        let importSelector = [];
        let entry_date = WrcGlobal.get_db_today();
        for (let i = 1; i < rows.length; i += 2) {
            let cells1 = rows[i].split("\t");
            let cells2 = rows[i + 1].split("\t");
            let names = cells1[2].split(", ");

            var scheduled_visit = {};
            scheduled_visit["visit_datetime"] = cells1[0].trim();
            scheduled_visit["last_name"] = names[0].trim();
            scheduled_visit["first_name"] = names[1].trim();
            scheduled_visit["birth_date"] = cells2[1].trim();
            scheduled_visit["mrn"] = cells2[2].trim();
            scheduled_visit["task"] = cells2[3].trim();
            scheduled_visit["entry_date"] = entry_date;

            cells1[cells1.length - 1] = [cells1[cells1.length - 1], cells2[0]];
            cells2 = cells2.slice(1);
            let cells = cells1.concat(cells2);
            cells = cells.map((cell) => {
                let tag = '';
                if (typeof cell === 'string') {
                    tag = (<td>{cell}</td>);
                }
                else if (Array.isArray(cell)) {
                    tag = (<td>{cell[0]}<br/>{cell[1]}</td>);
                }
                return tag;
            });

            let visit_date_parts = scheduled_visit["visit_datetime"].split(" ")[0].split("/");
            let date_of_birth_parts = scheduled_visit["birth_date"].split("/");
            let age = parseInt(visit_date_parts[2]) - parseInt(date_of_birth_parts[2]);
            if (parseInt(visit_date_parts[0]) > parseInt(date_of_birth_parts[0])) {
            }
            else if (parseInt(visit_date_parts[0]) < parseInt(date_of_birth_parts[0])) {
                age--;
            }
            else if (parseInt(visit_date_parts[1]) < parseInt(date_of_birth_parts[1])) {
                age--;
            }
            cells.push((<td>{age}</td>));

            importTable['rows'].push(cells);
            importTable['scheduled_visit_list'].push(scheduled_visit);

            let import_conditions_met=true;
            if (Array.isArray(this.props.import_conditions)){
                this.props.import_conditions.forEach((condition) =>{
                    let temp= true;
                    if(condition.type==="range"){
                        if(condition.field_name === "age"){
                            temp= age >= [condition.min] && age <= [condition.max];
                        }
                    }
                    import_conditions_met= import_conditions_met && temp;
                }, this);
            }
            if (import_conditions_met){
                importSelector.push('t');
            } else {
                importSelector.push('f');
            }
        }

        this.setState({
            importTable: importTable,
            readyImport: true,
            importSelector: importSelector
        });
    };

    afterSave = (content) => {
        this.props.refresh();
        this.closeSchedule();
    };

    clickImport = () => {
        var data = Object.assign({}, this.state.data);
        var today = WrcGlobal.get_db_today();

        data['entry_date'] = today;
        data['scheduled_visit'] = [];

        this.state.importTable.scheduled_visit_list.forEach(function(scheduled_visit, index) {
            if (this.state.importSelector[index] === 't') {
                scheduled_visit['entry_date'] = today;
                data['scheduled_visit'].push(scheduled_visit);
            }
        }.bind(this));

        var post = {
                table_schema: 'app',
                table_name: 'scheduling_search',
                data: data};
        WrcServer.post('save-form',
                post,
                (content) => this.afterSave(content)
        );
    };

    closeSchedule = () => {
        ReactDOM.unmountComponentAtNode(document.querySelector('#schedule'));
    };

    handleCheckbox = (index) => (e) => {
        e.persist();
        var importSelector = this.state.importSelector.slice();

        if (importSelector[index] === 't') {
            importSelector[index] = 'f';
        }
        else {
            importSelector[index] = 't';
        }
        this.setState({importSelector: importSelector});
    }
}

WrcSchedulingInputCP.propTypes = {
    registry: PropTypes.string.isRequired,
    component_index: PropTypes.number
};
